<template>
  <div class="contentbox">
    <div class="logo">
        <img src="/static/img/logo2.png" alt="" @click="$router.push('/')">
    </div>

    <div class="inqBox">
        <!-- <div class="header"> 
          <ul>
            <li>
              <a  @click="isSelect=0" :class="isSelect==0?'active':''">培训信息查询</a>
            </li>
            <li>
              <a  @click="isSelect=1" :class="isSelect==1?'active':''" >荣誉信息查询</a>
            </li>
          </ul>
           <a href="/" class="backhome">返回主页</a>
        </div> -->
        <h1><span v-if="isSelect==0">培训信息查询</span><span v-else-if="isSelect==1">荣誉信息查询</span><span v-else-if="isSelect==2">课题信息查询</span>  <a  class="backhome" href="/" >返回主页</a></h1>
        <div class="allbox">
          <div class="leftBox" v-show="isSelect==0">
            <el-select class="intype" v-model="cert.certtypename" placeholder="类别" @change="certtypechage">
              <el-option
                v-for="(certType,index) in arrCertTypes"
                :key="index"
                :label="certType.name.replace('职业人才技能等级证书','职业人才技能培训证书')"
                :value="certType.name">
              </el-option>
            </el-select>
            <div v-show="seltype=='gr'">
              <input type="text" v-model="cert.name" class="inname" placeholder="姓名"/>
              <input type="text" v-model="cert.cardid" class="inid" placeholder="证件号码"/>
              <input type="text" v-model="cert.code" class="incert" placeholder="证书编号"/>
            </div>
            <div v-show="seltype=='qy'">
              <input type="text" v-model="cert.qiyename" class="inname" placeholder="企业名称"/>
              <input type="text" v-model="cert.socialcreditcode" class="inid" placeholder="统一社会信用代码"/>
              <input type="text" v-model="cert.code" class="incert" placeholder="签发编号"/>
            </div>
            <button @click="submitForm() ">查询</button>
          </div>
          <div class="leftBox" v-show = "isSelect==1">
            <el-select class="intype" v-model="cert.certtypename" placeholder="类别" @change="certtypechage">
              <el-option
                v-for="(certType,index) in arrRongyTypes"
                :key="index"
                :label="certType.name"
                :value="certType.name">
              </el-option>
            </el-select>
            <div v-show="seltype=='gr'">
              <input type="text" v-model="cert.name" class="inname" placeholder="姓名"/>
              <input type="text" v-model="cert.code" class="incert" placeholder="证书编号"/>
            </div>
            <div v-show="seltype=='qy'">
              <input type="text" v-model="cert.qiyename" class="inname" placeholder="企业名称"/>
              <input type="text" v-model="cert.socialcreditcode" class="inid" placeholder="统一社会信用代码"/>
              <input type="text" v-model="cert.code" class="incert" placeholder="签发编号"/>
            </div>
            <button @click="submitForm() ">查询</button>
          </div>
          <div class="leftBox" v-show = "isSelect==2">
            <el-select class="intype" v-model="cert.certtypename" placeholder="类别">
              <el-option
                v-for="(certType,index) in arrKetiTypes"
                :key="index"
                :label="certType.name"
                :value="certType.name">
              </el-option>
            </el-select>
            <div>
              <input type="text" v-model="cert.name" class="inname" placeholder="课题名称"/>
              <input type="text" v-model="cert.code" class="incert" placeholder="课题编码"/>
            </div>
            <button @click="submitForm() ">查询</button>
          </div>
          <div class="rightBox">
            <div class="textBox">
              <!-- <h2>证书说明</h2>
              <p>持证人参加中国智慧工程研究会职业发展规划工作委员会组织的职业技能等级考试，考试合格。具备了该专业所要求的专业水平与职业技能。特发此证。</p> -->
              <h2 style="margin-top:26px">查询条件</h2>
              <p v-show="seltype=='gr'">
                1、点击证书类别，选择持有证书同类别项目名称点击确认；<br/>
                2、输入：人名+身份证号+证书编号点击查询；<br/>
                3、输入：人名+证书编号点击查询；<br/>
                4、输入：身份证号+证书编号点击查询；<br/>
                5、证书编码中若有英文字母全部需用大写字母填写；<br/>
                6、身份证号中若有英文字母全部需用大写字母填写。<br/>
              </p>
              <p v-show="seltype=='qy'">
                1、点击证书类别，选择持有证书同类别项目名称点击确认；<br/>
                2、输入：企业名称+统一社会信用代码+签发编号点击查询；<br/>
                3、输入：企业名称+签发编号点击查询；<br/>
                4、输入：统一社会信用代码+签发编号点击查询；<br/>
                5、签发编号中若有英文字母全部需用大写字母填写；<br/>
                6、统一社会信用代码中若有英文字母全部需用大写字母填写。<br/>
              </p>
            </div>
          </div>
        </div>
        <div class="btngroup">
          <ul >
            <li>
              <a  @click="isSelect=0" :class="isSelect==0?'active button':'button'">
                <span class="button__text">
                  {{isSelect==0?'证书查询':isSelect==1?'荣誉查询':'课题查询'}}
                </span>
              </a>
            </li>
            <li >
              <a :href="gourl" class="button">
                <span class="button__text">
                  证书说明
                </span>
              </a>
            </li>
            <li>
              <a href="/ExamLogin" class="button">
                <span class="button__text">
                  考试中心
                </span>
              </a>
            </li>
            <li >
              <a href="https://www.cnks.org.cn/kscx"  class="button">
                <span class="button__text">
                  查询考培证明
                </span>
              </a>
            </li>
          </ul>
          <img src="/static/img/niukou.png" class="kouniu1" alt=""/>
          <img src="/static/img/niukou.png" class="kouniu2" alt=""/>
        </div>
        
    </div>
    <el-dialog title="请选择荣誉名称" width="50%" :visible.sync="qyoccupationFlag">
        <el-form >
          <el-form-item label="荣誉名称">
            <el-select v-model="selcertname" placeholder="请选择荣誉名称">
              <el-option v-for="(cet,index) in occupations" :key="index" :label="cet.certname" :value="cet.certname">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="occupationFlag = false">取 消</el-button>
          <el-button type="primary" @click="qyhandleInq()">确 定</el-button>
        </div>
      </el-dialog>
    <el-dialog title="请选择职业名称" width="50%" :visible.sync="occupationFlag">
        <el-form >
          <el-form-item label="职业名称">
            <el-select v-model="selcertname" placeholder="请选择职业名称">
              <el-option v-for="(cet,index) in occupations" :key="index" :label="cet.certname" :value="cet.certname">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="occupationFlag = false">取 消</el-button>
          <el-button type="primary" @click="handleInq()">确 定</el-button>
        </div>
      </el-dialog>
  </div>
</template>

<script>

import { certificateGR ,certificateQY,getPersonalMember} from '@/request/index';
import { getCertTypes,getFindPage } from '@/request/get';
const rate = window.outerWidth / 1920;
export default {
  metaInfo: {
    title: '中国智慧工程研究会职业发展规划工作委员会',
    meta: [
      {
        name: 'viewport', content:
          `width=1920, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`
      }
    ]
  },
  name: "inquery",
  components: {
  },
  data() {
    return {
      occupations: [],
      occupationFlag:false,
      qyoccupationFlag:false,
      seltype:"gr",
      cert: {
        name: "",
        code:"",
        cardid:"",
        certtypename:""
      },
      selcertname:"",
      gourl:"",
      arrCertTypes:[],
      arrRongyTypes:[],
      arrKetiTypes:[],
      isSelect:0
    }
  },
  created(){
   this.getCertTypes();
   this.getFindPage();
   if(this.$route.query.inqtype=='ry')
   {
    this.isSelect=1;
   }else if(this.$route.query.inqtype=='kt')
   {
    this.isSelect=2;
   }else{
    this.isSelect=0;
   }

  },
  computed:{
    logopic() {
      return this.$store.getters.logopic;
    }
  },
  watch:{
    isSelect(){
      this.cert.certtypename = "";
    }
  },
  mounted() {
    var lastTouchEnd = 0;
    document.addEventListener(
      "touchend",
      function (event) {
        var now = new Date().getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      },
      false
    );
  },
  methods: {
    certtypechage(newval) {
      if(newval=="企业荣誉"){
        this.seltype='qy'
      }else{
        this.seltype='gr'
      }
    },
    async getFindPage() {
      let result = await getFindPage();
      result = result.data || [];
      this.$store.dispatch("SET_PLATES", result)
      let { plates } = this.$store.state;
    let list = plates.filter((item) => '证书说明' == item.name);
    let uuid = list[0].uuid;
    this.gourl = `/news/info/${uuid}/000000`
    },
    goHome() {
      this.$router.push("/");
    },
    handleInq() {
      if (!this.selcertname) {
        this.$message.error("请选择职业名称");
        return;
      }
      for(let i=0;i<this.occupations.length;i++)
      { 
        if(this.occupations[i].certname==this.selcertname)
        {
          this.cert = this.occupations[i];
          break;
        }
      }
      this.$router.push({
        name: "Show",
        query: {
          name: this.cert.name,
          code: this.cert.code,
          certtypename: this.cert.certtypename
        }
      })
    },
    qyhandleInq() {
      if (!this.selcertname) {
        this.$message.error("请选择荣誉名称");
        return;
      }
      for(let i=0;i<this.occupations.length;i++)
      { 
        if(this.occupations[i].certname==this.selcertname)
        {
          this.cert = this.occupations[i];
          break;
        }
      }
      this.$router.push({
        name: "Show",
        query: {
          name: this.cert.qiyename,
          code: this.cert.code,
          certtypename: this.cert.certtypename,
          type:'qy'
        }
      })
    },
    async getCertTypes(){
      let result = await getCertTypes();
      for(let i=0;i<result.data.length;i++) {
        if(result.data[i].type=='荣誉')
        {
          this.arrRongyTypes.push(result.data[i])
        }else if(result.data[i].type=='课题')
        {
          this.arrKetiTypes.push(result.data[i])
        }else{
          this.arrCertTypes.push(result.data[i])
        }
      }
    },
    /**
     *  cname: "单位名称"或姓名,
        ccode: "信用代码"或证件号,
        bzcode: "证书编号"或标准号
    */
    async submitForm() {
      if(!this.cert.certtypename)
      {
        this.$message.error("请选择证书类别");
        return;
      }
      if(this.seltype=='qy')
      {
        if ((this.qiyename == "" && this.code == "")
          || (this.qiyename == "" && this.socialcreditcode == "")
          || (this.code == "" && this.socialcreditcode == "")) {
          return;
        }
        let result =await certificateQY(this.cert.certtypename,this.cert.code,this.cert.qiyename,this.cert.socialcreditcode);
        if(result.data.length==1)
        {
          this.cert = result.data[0];
          this.$router.push({
            name: "Show",
            query: {
              name: this.cert.qiyename,
              code: this.cert.code,
              certtypename: this.cert.certtypename,
              type:'qy'
            }
          })
        }else if(result.data.length>1)
        {
          this.occupations = result.data || [];
          this.occupationFlag = true;
        }
      }else{
        if ((this.name == "" && this.code == "")
          || (this.name == "" && this.cardid == "")
          || (this.code == "" && this.cardid == "")) {
          return;
        }
        if(this.cert.certtypename.indexOf("荣誉")>-1)
        {
          if ((this.cert.name == "" && this.cert.code == "")) {
            return;
          }
          let result =await getPersonalMember(this.cert.name,this.cert.code);
          if(result.data.length>0)
          {
            this.$router.push({
              name: "MemberRlt",
              query: {
                name: this.cert.name,
                code: this.cert.code,
                inqType:"gr"
              }
            })
          }else{
            this.$message.error("您输入的信息不存在，谨防假冒。");
          }
          return
        }
        let result =await certificateGR(this.cert.certtypename,this.cert.code,this.cert.name,this.cert.cardid);
        if(result.data.length==1)
        {
          this.cert = result.data[0];
          this.$router.push({
            name: "Show",
            query: {
              name: this.cert.name,
              code: this.cert.code,
              certtypename: this.cert.certtypename,
              inqType:this.isSelect
            }
          })
        }else if(result.data.length>1)
        {
          this.occupations = result.data || [];
          this.occupationFlag = true;
        }
      }
      
    }
  }
};
</script>
<style scoped >

.logo{
    text-align: center;
    position: relative;
    top:98px;
}
.contentbox{
    height: 100%;
    background-color: #0157C6;
    background-image:url(/static/img/book_bg.png);
    background-size: contain;
    background-repeat: no-repeat;
}
.inqBox{
    position: relative;
    top: 128px;
    width: 1210px;
    height: 455px;
    background: rgba(255,255,255,0.3);
    /* background-image: url(/static/img/info_bg.png); */
    border-radius: 16px 16px 16px 16px;
    opacity: 1;
    margin: auto;
    padding: 29px;
    text-align: center;
    backdrop-filter: blur(5px);
}
.inqBox h1{
    font-size: 32px;
    
    font-weight: bold;
    color: #FFFFFF;
    line-height: 23px;
    text-align: center;
}
.leftBox input {
    width: 337.7px;
    height: 18.5px;
    margin-top:33px ;
    background: #F2F2F2;
    background-repeat: no-repeat;
    background-position: 9px 13px;
    border-radius: 8px 8px 8px 8px;
    
    font-size: 16px;
    padding: 14px 10px 14px 38px;
}
.leftBox .intype{
    width: 337.7px;
    height: 46.5px;
    background: #F2F2F2;
    background-repeat: no-repeat;
    background-position: 9px 13px;
    border-radius: 8px 8px 8px 8px;
    color: #bab9b9;
    font-size: 16px;
    padding: 0px 10px 0px 38px;
}
.leftBox .inid{
    background-image: url(/static/img/cardid.png);
}
.leftBox .incert{
    background-image: url(/static/img/book.png);
}
.leftBox .inname{
  background-image: url(/static/img/user.png);
}
.leftBox .intype{
  background-image: url(/static/img/type.png);
}
.leftBox button {
  width: 385.7px;
  height: 46.5px;
  margin-top: 29px;
  background: #0157C6;
  border-radius: 8px 8px 8px 8px;
  font-size: 24px;
  
  font-weight: bold;
  color: #FFFFFF;
  line-height: 28px;
}
.allbox{
  margin-top:45px;
  height: 369px;
  display: flex;
}
.leftBox{
  width:50%;
  /* height: */
  height: 369px;
  border-right:1px solid #D9D9D9; 
 
  display: inline-block;
}
.rightBox{
  width:49%;
  height: 369px;
  display: inline-block;
  position: relative;
  margin: auto;
  top: -23px;
  /* position: absolute; */
}
.textBox{
  height: 369px;
  width: 535px;
    text-align: left;
    margin-left: 92px;
}
.textBox h2{
  font-size: 20px;

font-weight: bold;
color: #FFFFFF;
}
.textBox p{
  margin-top:50px;
  font-size: 20px;
/* font-family: Inter-Regular, Inter; */
font-weight: 400;
color: #FFFFFF;
line-height: 40px;
}
.intype >>>.el-input__inner{
  background-color:transparent;
  border:none;
  height: 46px;
    line-height: 46px;
    padding:0px;
    font-size: 16px;
}
.btngroup{
  position: relative;
    top: -467px;
    left: -193px;
    color: #ffffff;
    font-size: 20px;
    width: 156px;
    height:189px;
    padding-top: 40px;
    background: rgba(255,255,255,0.3);
    backdrop-filter: blur(5px);
    border-radius: 8px;
}
.btngroup ul li {
  margin-bottom: 26px;
  
}
.btngroup ul li a{
  color:rgba(255,255,255,0.5);
}
.btngroup ul li:first-child a{
  font-size: 24px;
  color: #ffffff;
  font-weight: bold;
  border-bottom:solid 2px rgba(255,255,255,0.8);
 
}
.kouniu1{
  position: relative;
    top: -180px;
    left: 110px;
    width: 52px;
}
.kouniu2{
  position: relative;
    top: -67px;
    left: 57px;
    width: 52px;
}
.inqBox .backhome{
  font-size: 14px;
    float: right;
    color: #fff;
    border-bottom: solid 1px;
}
.inqBox .header ul{
  display: flex;
  /* width: 500px;
  padding-left: 55px; */
  width: 1200px;
}
.inqBox .header ul li{
  
  display: inline-block;
  width: 600px;
  
}
.inqBox .header ul li a{
  font-size: 20px;
  /* border-bottom: solid 1px; */
  color: #fff;
}
.active span{
  /* color: #ffcc1a;
  border-bottom:#ffcc1a; */
}
.btntwo{
  margin-top:40px;
}
.btntwo .kouniu2{
 top: -88px
}
.btntwo .kouniu1{
  top:38px;
}
</style>
